import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=2f5864bb&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"
import style0 from "./chart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chart.vue?vue&type=style&index=1&id=2f5864bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5864bb",
  null
  
)

export default component.exports